import Noty from "noty";

class Notification {
  show(type, message) {
    new Noty({
      type: type,
      text: message,
      layout: "topRight",
      theme: "nest",
      timeout: "3000",
      progressBar: true
    }).show();
  }

  success(message) {
    this.show("success", message);
  }
  error(message) {
    this.show("error", message);
  }
}

export default new Notification();
